module.exports = __webpack_public_path__ + "static/long-dcbb573567d8ae2c5299be9e59c3995e.png";